/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_Updates_TermInputs */

const en_marketing_faq_updates_term = /** @type {(inputs: Marketing_Faq_Updates_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do updates arrive?`)
};

const es_marketing_faq_updates_term = /** @type {(inputs: Marketing_Faq_Updates_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo llegan las actualizaciones?`)
};

const fr_marketing_faq_updates_term = /** @type {(inputs: Marketing_Faq_Updates_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment arrivent les mises à jour ?`)
};

/**
* | output |
* | --- |
* | "How do updates arrive?" |
*
* @param {Marketing_Faq_Updates_TermInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_updates_term = /** @type {((inputs?: Marketing_Faq_Updates_TermInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_Updates_TermInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_updates_term(inputs)
	if (locale === "es") return es_marketing_faq_updates_term(inputs)
	return fr_marketing_faq_updates_term(inputs)
});